import { render, staticRenderFns } from "./editxz.vue?vue&type=template&id=d8437a44&scoped=true&"
import script from "./editxz.vue?vue&type=script&lang=js&"
export * from "./editxz.vue?vue&type=script&lang=js&"
import style0 from "./editxz.vue?vue&type=style&index=0&id=d8437a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8437a44",
  null
  
)

export default component.exports